/*
 * Ordnet einem Label eine Weiterbildungsart über den key zu
 *
 * Die wird so dargestellt, wie sie im vorgegeben Array ist
 */

import { FacettenOptionInfo } from '../services/facetten/facetten-option-info';

/**
 * Repräsentation der Weiterbildungsart aus dem Backend
 */
export enum Weiterbildungsart {
  BERUFLICHE_QUALIFIZIERUNG = 'BERUFLICHE_QUALIFIZIERUNG',
  AUFSTIEGSWEITERBILDUNG = 'AUFSTIEGSWEITERBILDUNG',
  REHA_ANGEBOTE = 'REHA_ANGEBOTE',
  UMSCHULUNG = 'UMSCHULUNG',
  BERUFSABSCHLUSS_NACHHOLEN = 'BERUFSABSCHLUSS_NACHHOLEN',
  TEILQUALIFIZIERUNG = 'TEILQUALIFIZIERUNG',
  BEGLEITENDE_HILFEN = 'BEGLEITENDE_HILFEN'
}

/**
 * backendId ist die ID die zwischen unseren UI und unseren Backend gesendet wird.
 */
export type FacettenOptionInfoWeiterbildungsart = FacettenOptionInfo & {
  backendId: Weiterbildungsart;
};

/**
 * systematikIds sind die Systematiken C, D, RC und RD
 */
export type FacettenOptionInfoWeiterbildungsartWithSystematik =
  FacettenOptionInfoWeiterbildungsart & {
    // TODO evtl kann man die logik mit systematikIds ausbauen, da die Id jetzt wieder eine Systemik sein kein (C, D, RC und RD)
    // Problem ist nur dass bei REHA 2 Ids gesetzt werden sollen
    systematikIds?: string[];
  };

const weiterbildungsartReha: FacettenOptionInfoWeiterbildungsartWithSystematik = {
  id: 'R',
  backendId: Weiterbildungsart.REHA_ANGEBOTE,
  bezeichnung: 'Reha-Angebote',
  systematikIds: ['RC', 'RD']
};

export const orderedWeiterbildungsartenWeiterbildungsangebote: FacettenOptionInfoWeiterbildungsartWithSystematik[] =
  [
    {
      id: 'C',
      backendId: Weiterbildungsart.BERUFLICHE_QUALIFIZIERUNG,
      bezeichnung: 'Berufliche Qualifizierung'
    },
    {
      id: 'D',
      backendId: Weiterbildungsart.AUFSTIEGSWEITERBILDUNG,
      bezeichnung: 'Aufstiegsweiterbildung'
    },
    weiterbildungsartReha
  ];

export const orderedWeiterbildungsartenUteAngebote: FacettenOptionInfoWeiterbildungsartWithSystematik[] =
  [
    {
      id: 'U',
      backendId: Weiterbildungsart.UMSCHULUNG,
      bezeichnung: 'Umschulung'
    },
    {
      id: 'T',
      backendId: Weiterbildungsart.TEILQUALIFIZIERUNG,
      bezeichnung: 'Teilqualifizierung'
    },
    {
      id: 'E',
      backendId: Weiterbildungsart.BERUFSABSCHLUSS_NACHHOLEN,
      bezeichnung: 'Vorbereitung Externenprüfung'
    },
    {
      id: 'UBH',
      backendId: Weiterbildungsart.BEGLEITENDE_HILFEN,
      bezeichnung: 'Begleitende Hilfen'
    },
    weiterbildungsartReha
  ];

export const orderedWeiterbildungsarten: FacettenOptionInfoWeiterbildungsartWithSystematik[] = [
  ...orderedWeiterbildungsartenWeiterbildungsangebote,
  ...orderedWeiterbildungsartenUteAngebote
];

export const getLabelFromWeiterbildungsart = (weiterbildungsart: Weiterbildungsart): string => {
  return (
    orderedWeiterbildungsarten.find((wbart) => wbart.backendId === weiterbildungsart)
      ?.bezeichnung || ''
  );
};
